import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import styled from '../../styles/styled';
const Rectangle = styled.div(props => {
    return {
        position: 'absolute',
        width: '20px',
        height: '2px',
        transform: `rotate(${props.rotation}deg)`,
        borderRadius: '1px',
        backgroundColor: props.theme.colors.grey90,
        cursor: 'pointer',
    };
});
const ButtonWrapper = styled.button({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '20px',
    height: '20px',
    marginLeft: '10px',
    border: 'none',
    cursor: 'pointer',
    backgroundColor: 'transparent',
});
export const CloseButton = props => {
    return (_jsxs(ButtonWrapper, { "aria-label": props.label, ...props, children: [_jsx(Rectangle, { rotation: 45 }), _jsx(Rectangle, { rotation: -45 })] }));
};
//# sourceMappingURL=close_button.js.map